<div class="text-center mt-5" style="color: #f15c23">
    <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Loading...</span>
      </div>
</div>

<p *ngIf="isLoggedIn$ | async">Attempting to automatically authenticate....</p>
